import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ANIMATION_LIST} from './animation-list';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {LazyLoaderService} from '@common/core/utils/lazy-loader.service';

type propagateFn = (value: string) => void;

@Component({
    selector: 'animation-selector',
    templateUrl: './animation-selector.component.html',
    styleUrls: ['./animation-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: AnimationSelectorComponent,
            multi: true,
        },
    ],
})
export class AnimationSelectorComponent
    implements OnInit, ControlValueAccessor
{
    animationList = ANIMATION_LIST;
    selectedAnimation$ = new BehaviorSubject<string>(null);
    private propagateChange: propagateFn;

    constructor(private lazyLoader: LazyLoaderService) {}

    ngOnInit() {
        this.lazyLoader.loadAsset(
            'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css',
            {type: 'css', id: 'animate.css'}
        );
    }

    registerOnChange(fn: propagateFn) {
        this.propagateChange = fn;
    }

    writeValue(value: string) {
        this.selectedAnimation$.next(value);
    }

    registerOnTouched(fn: any) {}

    selectAnimation(animation: string) {
        this.propagateChange(animation);
        this.selectedAnimation$.next(animation);
    }

    onMouseEnter(e: MouseEvent, animation: string) {
        (e.target as HTMLElement).classList.add(`animate__${animation}`);
    }

    onMouseLeave(e: MouseEvent, animation: string) {
        (e.target as HTMLElement).classList.remove(`animate__${animation}`);
    }
}
